import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramOverviewComponent } from './program-overview.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramOverviewComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramOverviewRoutingModule { }
